
// FOR TESTING (add Javis if different):
const LOCAL_DOMAINS = ["localhost", "127.0.0.1", "8.8.8.8",];

let url_prefix      = "ajax/";

if (LOCAL_DOMAINS.includes(window.location.hostname)) {
  url_prefix = "http://localhost/_gesemal/tarjeta-fidelidad/app/ajax/";
  console.warn("running on localhost");
} 

const ajax = {

  login: "login",                   // Not used
  passwordchange: "password_change", 

  // TBD - socio table endpoints
   puntos: "puntos",
   vouchers: "vouchers",
   reservas: "reservas",
   mis_datos: "user",
   user_update: "user_update",
   newuser: "user_alta",
   coupon_generate: "coupon_generate",

  get(a: string): string {
    return url_prefix + (this as any)[a];
  },

  sync_step: 0,

}


export { ajax };